import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, InputNumber, Row } from 'antd';
import { useContext } from 'react';
import { PageContext } from '../../../lib/context';

const RatesForm = () => {
  const { form, _onFinish, customRates, _addNewRate, _deleteRate } =
    useContext(PageContext);
  return (
    <Form layout="vertical" form={form} onFinish={_onFinish}>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Name is required' }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      {customRates.map((val: any, index: number) => {
        return (
          <Row gutter={16} key={index}>
            <Col span={7}>
              <Form.Item
                label="Rate Name"
                rules={[{ required: true, message: 'Name rate is required' }]}
                name={`name_${index}`}
                initialValue={val.name}
              >
                <Input style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item
                label="Rate"
                rules={[
                  { required: true, message: 'Rate is required' },
                  { min: 1, message: 'Minimum value is 1', type: 'integer' },
                ]}
                name={`rate_${index}`}
                initialValue={val.rate}
              >
                <InputNumber style={{ width: '100%' }} min={0} />
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item
                label="Minimum Rate"
                rules={[
                  { required: true, message: 'Minimum rate is required' },
                  { min: 1, message: 'Minimum value is 1', type: 'integer' },
                ]}
                name={`minimum_${index}`}
                initialValue={val.minimum}
              >
                <InputNumber style={{ width: '100%' }} min={0} />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item label=".">
                {index === 0 ? (
                  <Button type="link" onClick={_addNewRate}>
                    <PlusOutlined />
                  </Button>
                ) : (
                  <Button type="link" onClick={() => _deleteRate(index)}>
                    <MinusOutlined />
                  </Button>
                )}
              </Form.Item>
            </Col>
            <Form.Item name="id" hidden>
              <Input />
            </Form.Item>
          </Row>
        );
      })}
      {/* <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Second"
            rules={[{ required: true, message: 'Second is required' }]}
            name="second"
            initialValue={0}
          >
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Second Rate"
            rules={[{ required: true, message: 'Second rate is required' }]}
            name="second_rate"
            initialValue={0}
          >
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Third"
            rules={[{ required: true, message: 'Third is required' }]}
            name="third"
            initialValue={0}
          >
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Third Rate"
            rules={[{ required: true, message: 'Third rate is required' }]}
            name="third_rate"
            initialValue={0}
          >
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Fourth"
            rules={[{ required: true, message: 'Fourth is required' }]}
            name="fourth"
            initialValue={0}
          >
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Fourth Rate"
            rules={[{ required: true, message: 'Fourth rate is required' }]}
            name="fourth_rate"
            initialValue={0}
          >
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
      </Row> */}
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label="Rate Type"
            rules={[
              { required: true, message: 'Rate type is required' },
              { min: 1, message: 'Minimum rate type is 1', type: 'number' },
            ]}
            name="rate_type"
            initialValue={0}
          >
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default RatesForm;
